import content from './content.js';
import custom_profile_fields from './custom-profile-fields.js';
import sign_up_and_sign_in from './sign-up-and-sign-in.js';
const sign_in_exp = {
    page_title: 'Опыт входа в систему',
    page_title_with_account: 'Вход и аккаунт',
    title: 'Вход и аккаунт',
    description: 'Настройте потоки аутентификации и пользовательский интерфейс, и просматривайте готовый опыт в реальном времени.',
    tabs: {
        branding: 'Брендирование',
        sign_up_and_sign_in: 'Регистрация и вход в систему',
        collect_user_profile: 'Сбор профиля пользователя',
        account_center: 'Центр аккаунта',
        content: 'Содержание',
        password_policy: 'Политика пароля',
    },
    welcome: {
        title: 'Настройка входа в систему',
        description: 'Начните быстро с настройки первого входа в систему. Это руководство поможет вам пройти все необходимые настройки.',
        get_started: 'Начать',
        apply_remind: 'Обратите внимание, что опыт входа в систему будет применяться для всех приложений в этой учетной записи.',
    },
    color: {
        title: 'ЦВЕТ',
        primary_color: 'Цвет бренда',
        dark_primary_color: 'Цвет бренда (темный)',
        dark_mode: 'Включить темный режим',
        dark_mode_description: 'Ваше приложение будет иметь автоматически созданную темную тему на основе цвета вашего бренда и алгоритма Logto. Вы можете настроить ее по своему вкусу.',
        dark_mode_reset_tip: 'Пересчитать цвет темного режима на основе цвета бренда.',
        reset: 'Пересчитать',
    },
    branding: {
        title: 'ЗОНА БРЕНДИНГА',
        ui_style: 'Стиль',
        with_light: '{{value}}',
        with_dark: '{{value}} (dark)',
        app_logo_and_favicon: 'Логотип приложения и иконка',
        company_logo_and_favicon: 'Логотип компании и иконка',
        organization_logo_and_favicon: 'Логотип организации и иконка',
        hide_logto_branding: 'Скрыть брендинг Logto',
        hide_logto_branding_description: 'Удалите надпись "Powered by Logto". Подчеркните только свой бренд с помощью чистого и профессионального процесса входа.',
        hide_logto_branding_oss_note: 'Эта функция нативно доступна в <a>Logto Cloud</a>.',
    },
    branding_uploads: {
        app_logo: {
            title: 'Логотип приложения',
            url: 'URL логотипа приложения',
            url_placeholder: 'https://your.cdn.domain/logo.png',
            error: 'Логотип приложения: {{error}}',
        },
        company_logo: {
            title: 'Логотип компании',
            url: 'URL логотипа компании',
            url_placeholder: 'https://your.cdn.domain/logo.png',
            error: 'Логотип компании: {{error}}',
        },
        organization_logo: {
            title: 'Загрузить изображение',
            url: 'URL логотипа организации',
            url_placeholder: 'https://your.cdn.domain/logo.png',
            error: 'Логотип организации: {{error}}',
        },
        connector_logo: {
            title: 'Загрузить изображение',
            url: 'URL логотипа соединителя',
            url_placeholder: 'https://your.cdn.domain/logo.png',
            error: 'Логотип соединителя: {{error}}',
        },
        favicon: {
            title: 'Иконка',
            url: 'URL иконки',
            url_placeholder: 'https://your.cdn.domain/favicon.ico',
            error: 'Иконка: {{error}}',
        },
    },
    custom_ui: {
        title: 'Пользовательский интерфейс',
        cloud_tag: 'Cloud',
        css_code_editor_title: 'Пользовательский CSS',
        css_code_editor_field_title: 'Переопределение CSS',
        css_code_editor_description1: 'См. пример пользовательского CSS.',
        css_code_editor_description2: '<a>{{link}}</a>',
        css_code_editor_description_link_content: 'Узнать больше',
        css_code_editor_content_placeholder: 'Введите здесь свои переопределения CSS, чтобы точно настроить стили любых элементов под ваши требования. Проявите креативность и выделите свой UI.',
        bring_your_ui_title: 'Создайте свой интерфейс',
        bring_your_ui_upload_title: 'Загрузить пользовательские ресурсы UI',
        bring_your_ui_description: 'Загрузите сжатый пакет (.zip), чтобы заменить предустановленный интерфейс Logto вашим собственным кодом. <a>Узнать больше</a>',
        bring_your_ui_oss_description: 'Настройте интерфейс входа с помощью собственного кода.',
        bring_your_ui_oss_card_description: 'Загрузите свой пользовательский интерфейс входа прямо в <a>Logto Cloud</a>. Не нужно делать форк и повторно развёртывать.',
        bring_your_ui_oss_try_cloud: 'Попробовать Cloud',
        preview_with_bring_your_ui_description: 'Ваши пользовательские ресурсы интерфейса успешно загружены и теперь доступны. Встроенное окно предварительного просмотра отключено.\nДля тестирования персонализированного интерфейса входа нажмите кнопку "Прямая трансляция" для открытия в новой вкладке браузера.',
        csp_description: 'Разрешите дополнительные выражения источников для пользовательского интерфейса входа. Эти значения применяются только при обслуживании пользовательских ресурсов UI.',
        csp_script_src: 'Разрешённые script-src',
        csp_script_src_tip: 'Разрешите выражения источников HTTPS для скриптов, загружаемых вашим пользовательским UI, например https://scripts.example.com или https://*.example.com.',
        csp_connect_src: 'Разрешённые connect-src',
        csp_connect_src_tip: 'Разрешите выражения источников HTTPS или WSS для сетевых запросов вашего пользовательского UI, например https://api.example.com или wss://events.example.com.',
        csp_source_invalid_error: 'Введите допустимое выражение источника. Используйте URL с https://; connect-src также поддерживает wss://. Ключевые слова CSP и точки с запятой не поддерживаются.',
        csp_source_duplicate_error: 'Это выражение источника уже есть в списке.',
    },
    account_center: {
        title: 'ЦЕНТР УЧЁТНОЙ ЗАПИСИ',
        description: 'Настройте процессы центра учётной записи с помощью API Logto.',
        enable_account_api: 'Включить центр учётной записи и Account API',
        enable_account_api_description: 'Одновременно включает Account API для конечных пользователей и готовый центр аккаунта Logto. При отключении обе функции недоступны.',
        field_options: {
            off: 'Выключено',
            edit: 'Редактировать',
            read_only: 'Только чтение',
            enabled: 'Включено',
            disabled: 'Отключено',
        },
        sections: {
            account_security: {
                title: 'БЕЗОПАСНОСТЬ УЧЁТНОЙ ЗАПИСИ',
                description: 'Управляйте доступом к Account API, чтобы пользователи после входа в приложение могли просматривать или изменять сведения о личности и факторы аутентификации.',
                security_verification: {
                    title: 'Проверка безопасности',
                    description: 'Прежде чем изменять настройки безопасности, пользователи должны подтвердить свою личность и получить идентификатор записи проверки, действительный в течение 10 минут. Чтобы включить метод проверки (электронная почта, телефон, пароль), установите разрешение Account API ниже на <strong>Только чтение</strong> (минимум) или <strong>Редактировать</strong>, чтобы система могла определить, настроил ли пользователь его. <a>Подробнее</a>',
                },
                groups: {
                    identifiers: {
                        title: 'Идентификаторы',
                    },
                    authentication_factors: {
                        title: 'Факторы аутентификации',
                    },
                    session_management: {
                        title: 'Управление сессиями',
                    },
                },
            },
            user_profile: {
                title: 'ПРОФИЛЬ ПОЛЬЗОВАТЕЛЯ',
                description: 'Управляйте доступом к Account API, чтобы пользователи после входа могли просматривать или изменять базовые или собственные данные профиля.',
                groups: {
                    profile_data: {
                        title: 'Данные профиля',
                    },
                },
            },
            secret_vault: {
                title: 'СЕКРЕТНОЕ ХРАНИЛИЩЕ',
                description: 'Для социальных и корпоративных коннекторов безопасно храните токены доступа третьих сторон, чтобы вызывать их API (например, добавлять события в Google Календарь).',
                third_party_token_storage: {
                    title: 'Токен третьей стороны',
                    third_party_access_token_retrieval: 'Получение токена доступа третьей стороны',
                    third_party_token_tooltip: 'Чтобы сохранять токены, включите эту опцию в настройках соответствующего социального или корпоративного коннектора.',
                    third_party_token_description: 'После включения Account API получение токенов третьих сторон активируется автоматически.',
                },
            },
        },
        fields: {
            email: 'Адрес электронной почты',
            phone: 'Номер телефона',
            social: 'Социальные идентификаторы',
            password: 'Пароль',
            mfa: 'Многофакторная аутентификация',
            mfa_description: 'Разрешите пользователям управлять методами MFA в центре учётной записи.',
            passkey: 'Passkey',
            username: 'Имя пользователя',
            name: 'Имя',
            avatar: 'Аватар',
            profile: 'Профиль',
            profile_description: 'Управляйте доступом к структурированным атрибутам профиля.',
            custom_data: 'Пользовательские данные',
            custom_data_description: 'Управляйте доступом к пользовательским JSON-данным, хранящимся у пользователя.',
            sessions: 'Сессии',
            trusted_devices: 'Доверенные устройства',
        },
        profile_fields: {
            title: 'Поля профиля для готового центра учётной записи',
            add_profile_fields: 'Добавить поля профиля',
            hint: {
                not_in_list: 'Нет в списке?',
                set_up: 'Настроить',
                go_to: 'другие поля профиля сейчас.',
            },
            disabled_hint: {
                name: 'Чтобы добавить это поле, сначала установите разрешение «Имя» в значение «Редактировать/Только чтение» в разделе «Профиль пользователя» ниже.',
                avatar: 'Чтобы добавить это поле, сначала установите разрешение «Аватар» в значение «Редактировать/Только чтение» в разделе «Профиль пользователя» ниже.',
                profile: 'Чтобы добавить это поле, сначала установите разрешение «Профиль» в значение «Редактировать/Только чтение» в разделе «Профиль пользователя» ниже.',
                custom_data: 'Чтобы добавить это поле, сначала установите разрешение «Пользовательские данные» в значение «Редактировать/Только чтение» в разделе «Профиль пользователя» ниже.',
            },
        },
        webauthn_related_origins: 'Связанные источники WebAuthn',
        webauthn_related_origins_description: 'Добавьте домены ваших фронтенд-приложений, которым разрешено регистрировать passkey через Account API.',
        webauthn_related_origins_error: 'Источник должен начинаться с https:// или http://',
        delete_account_url: 'Удалить аккаунт',
        delete_account_url_description: 'Укажите собственный URL конечной точки, чтобы обрабатывать удаление аккаунта с пользовательской логикой.',
        prebuilt_ui: {
            title: 'ИСПОЛЬЗОВАТЬ ГОТОВЫЙ ИНТЕРФЕЙС',
            description: 'Быстро интегрируйте готовый центр аккаунта, проверку безопасности или единичный поток обновления профиля с готовым интерфейсом. Просто объедините ваш домен с маршрутом, чтобы сформировать URL центра аккаунта (например, https://auth.foo.com/account/email).',
            permission_notice: 'Для интеграции этих готовых потоков установите соответствующие разрешения Account API на <strong>Редактирование</strong> в настройках ниже.',
            account_center_title: 'Интегрируйте готовый центр аккаунта',
            account_center_description: 'Направляйте пользователей в центр аккаунта для управления настройками безопасности, такими как электронная почта, телефон, имя пользователя, пароль, MFA и подключённые аккаунты.',
            flows_title: 'Интегрируйте готовые потоки настройки безопасности',
            single_task_flows_title: 'Интегрируйте готовый поток для одной задачи',
            flows_description: 'Объедините ваш домен с маршрутом, чтобы сформировать URL настроек аккаунта (например, https://auth.foo.com/account/email). При желании добавьте `redirect=` для возврата пользователей в ваше приложение после успешного обновления, `show_success=true` для отображения страницы успеха, `ui_locales=` для переопределения языка по умолчанию, или `identifier=` для предварительного заполнения поля ввода идентификатора.',
            single_task_flows_description: 'Направляйте пользователей сразу в определённый поток (например, привязка email). При желании добавьте `redirect=` для возврата пользователей в ваше приложение после успешного обновления, `show_success=true` для отображения страницы успеха, `ui_locales=` для переопределения языка по умолчанию, или `identifier=` для предварительного заполнения поля ввода идентификатора.',
            tooltips: {
                email: 'Обновите ваш основной адрес электронной почты',
                phone: 'Обновите ваш основной номер телефона',
                username: 'Обновите ваше имя пользователя',
                password: 'Установите новый пароль',
                social: 'Подключите социальный аккаунт для входа',
                social_change: 'Переключитесь на другой подключенный социальный аккаунт',
                social_remove: 'Удалите подключенный социальный аккаунт',
                authenticator_app: 'Настройте новое приложение-аутентификатор для многофакторной аутентификации',
                authenticator_app_replace: 'Замените существующее приложение для аутентификации на новое',
                passkey_add: 'Зарегистрируйте новый ключ доступа',
                passkey_manage: 'Управляйте вашими существующими ключами или добавляйте новые',
                backup_codes_generate: 'Сгенерируйте новый набор из 10 резервных кодов',
                backup_codes_manage: 'Просмотрите доступные резервные коды или сгенерируйте новые',
                account_center: 'Откройте центр аккаунта для управления настройками безопасности, такими как электронная почта, телефон, имя пользователя, пароль, MFA и подключённые аккаунты',
                profile: 'Центральный узел для управления вашей личной информацией (например, имя, аватар)',
                sessions: 'Просмотр и управление активными сеансами на всех устройствах',
            },
            customize_note: 'Не хотите использовать базовый опыт? Вы можете полностью',
            customize_link: 'настроить ваши потоки с помощью Account API.',
        },
        custom_css: {
            title: 'Пользовательский CSS',
            description: 'Настройте внешний вид центра учетных записей с помощью пользовательского CSS.',
        },
    },
    sign_up_and_sign_in,
    content,
    setup_warning: {
        no_connector_sms: 'Еще не настроен коннектор SMS. Пока не завершено настройка, пользователи не смогут войти с помощью этого метода. <a>{{link}}</a> в «Коннекторах»',
        no_connector_email: 'Еще не настроен коннектор по электронной почте. Пока не завершено настройка, пользователи не смогут войти с помощью этого метода. <a>{{link}}</a> в «Коннекторах»',
        no_connector_social: 'Вы еще не настроили социальный коннектор. Сначала добавьте коннекторы, чтобы применить методы социальной авторизации. <a>{{link}}</a> в разделе "Коннекторы".',
        no_connector_email_account_center: 'Коннектор электронной почты еще не настроен. Настройте в <a>«Коннекторы электронной почты и SMS»</a>.',
        no_connector_sms_account_center: 'Коннектор SMS еще не настроен. Настройте в <a>«Коннекторы электронной почты и SMS»</a>.',
        no_connector_social_account_center: 'Социальный коннектор еще не настроен. Настройте в <a>«Социальные коннекторы»</a>.',
        no_mfa_factor: 'Еще не настроен фактор MFA. Настройте в <a>{{link}}</a>.',
        setup_link: 'Настройка',
    },
    save_alert: {
        description: 'Вы внедряете новые процедуры входа и регистрации. Все ваши пользователи могут быть затронуты новой настройкой. Вы точно хотите внести изменения?',
        before: 'До',
        after: 'После',
        sign_up: 'Регистрация',
        sign_in: 'Вход',
        social: 'Социальный',
        forgot_password_migration_notice: 'Мы обновили проверку забытого пароля для поддержки пользовательских методов. Ранее это автоматически определялось вашими коннекторами электронной почты и SMS. Нажмите <strong>Подтвердить</strong>, чтобы завершить обновление.',
    },
    preview: {
        title: 'Предварительный просмотр входа в систему',
        live_preview: 'Прямой эфир',
        live_preview_tip: 'Сохранить для просмотра изменений',
        native: 'Нативный',
        desktop_web: 'Веб на рабочем столе',
        mobile_web: 'Мобильный веб',
        desktop: 'Рабочий стол',
        mobile: 'Мобильный',
    },
    custom_profile_fields,
};
export default Object.freeze(sign_in_exp);
